/**
Author - Babajan khan
Github - https://www.github.com/babajanpatan/
**/

import NewFaqs from "./NewFaqs.container";

export default NewFaqs;
